import { useTranslate, useGetLocale } from '@refinedev/core';
import { Typography, Tag, Table } from 'antd';
import type { ContentProductThemaCodeOut } from '@/api/generated/schemas';

const { Title } = Typography;

export const ProductThemaCodesTab = ({
  themaCodes,
}: {
  themaCodes: ContentProductThemaCodeOut[];
}) => {
  const t = useTranslate();
  const getLocale = useGetLocale();
  const locale = getLocale();

  if (themaCodes.length === 0) {
    return (
      <Typography.Text type="secondary">
        {t('content_catalog.products.thema_codes.not_available')}
      </Typography.Text>
    );
  }

  return (
    <>
      <Title level={4}>{t('content_catalog.products.thema_codes.title')}</Title>
      <Table<ContentProductThemaCodeOut>
        dataSource={themaCodes}
        rowKey="thema_code_id"
        pagination={false}
        size="small"
      >
        <Table.Column
          dataIndex="code"
          title={t('content_catalog.products.thema_codes.fields.code')}
          render={(value: string) =>
            value ? (
              <Typography.Link
                href={`https://ns.editeur.org/thema/${locale}/${value}`}
                target="_blank"
              >
                {value}
              </Typography.Link>
            ) : (
              '-'
            )
          }
        />
        <Table.Column
          dataIndex="thema_code_id"
          title={t('content_catalog.products.thema_codes.fields.thema_code_id')}
        />
        <Table.Column
          dataIndex="is_main"
          title={t('content_catalog.products.thema_codes.fields.is_main')}
          render={(value: boolean) => (
            <Tag color={value ? 'green' : 'default'}>
              {value ? t('common.yes') : t('common.no')}
            </Tag>
          )}
        />
      </Table>
    </>
  );
};
